import React, { Component } from 'react';
import HeaderTwo from './components/HeaderTwo';
import HeroImage from './components/HeroImage';
import AboutUsTwo from './components/AboutUsTwo';
import FreeCourse from './components/FreeCourse';
import HomeBlog from './components/HomeBlog';
import StepsSection from './components/StepsSection';
import FooterTwo from './components/FooterTwo';

export default class HomeTwo extends Component {
    render() {
        return (
            <div className="main-wrapper">

                {/* Header 2 */}
                <HeaderTwo />

                {/* Hero Image */}
                <HeroImage />

                {/* Blog Area */}
                <HomeBlog />

                {/* Steps Section */}
                <StepsSection />

                {/* About Us 2 */}
                <AboutUsTwo />

                {/* Free Course Area */}
                <FreeCourse />

                {/* Footer 2 */}
                <FooterTwo />

            </div>
        )
    }
}
